"use client";
import { useTheme } from "../../contexts/ThemeContext";
import { BsSun, BsMoon } from "react-icons/bs";
import "./theme-toggle.css";

const ThemeToggle = () => {
  const { isDarkMode, toggleTheme } = useTheme();

  return (
    <button
      className="theme-toggle"
      onClick={toggleTheme}
      aria-label={`Switch to ${isDarkMode ? "dark" : "light"} mode`}
    >
      {isDarkMode ? (
        <BsSun className="theme-icon" />
      ) : (
        <BsMoon className="theme-icon" />
      )}
    </button>
  );
};

export default ThemeToggle;
